export enum PieChart {
    Opened = 0,
    Closed = 1,
    NotValidated = 2
}